// import React, { useState, useRef, useEffect } from 'react';
// import { 
//   FaBuilding, FaEnvelope, FaCreditCard, FaGlobe, 
//   FaPalette, FaSave, FaUpload, FaCheckCircle, 
//   FaMobileAlt, FaClock, FaCoins, FaTimes
// } from 'react-icons/fa';
 
// import './SystemSettings.css';
// import { useSettings } from '../../context/SettingsContext';

// const SystemSettings = () => {
  
//   const { globalSettings, updateSettings } = useSettings();

//   const [activeSection, setActiveSection] = useState('company');
//   const [savedStatus, setSavedStatus] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingTemplate, setEditingTemplate] = useState(null);
//   const fileInputRef = useRef(null);

 
//   const [settings, setSettings] = useState({
//     companyName: globalSettings.companyName || 'Iconic Green Land',
//     email: globalSettings.email || 'admin@iconicgreenland.com',
//     phone: globalSettings.phone || '+880 1711-000000',
//     currency: globalSettings.currency || 'BDT',
//     timezone: globalSettings.timezone || 'UTC+6 (Dhaka)',
//     primaryColor: globalSettings.primaryColor || '#4f46e5',
//     gateway: globalSettings.gateway || 'Bkash',
//     logo: globalSettings.logo || null,
//     address: globalSettings.address || '3 RK Mission Rd, Dhaka, Bangladesh'
//   });

 
//   useEffect(() => {
//     if (globalSettings) {
//       setSettings((prev) => ({ ...prev, ...globalSettings }));
//     }
//   }, [globalSettings]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setSettings({ ...settings, [name]: value });
    
//     // Live Theme Update (Instant Feedback for user)
//     if (name === 'primaryColor') {
//       document.documentElement.style.setProperty('--primary', value);
//     }
//   };

//   const handleLogoUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSettings({ ...settings, logo: reader.result });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const openTemplateEditor = (type) => {
//     setEditingTemplate(type);
//     setIsModalOpen(true);
//   };

//   const handleSave = () => {
    
//     updateSettings(settings);

//     setSavedStatus(true);
//     setTimeout(() => setSavedStatus(false), 3000);
//   };

//   return (
//     <div className="doc-wrapper">
//       <div className="doc-container">
        
//         <header className="doc-header">
//           <div className="header-text">
//             <h1>System Configuration</h1>
//             <p>Manage global parameters, branding assets, and integration keys.</p>
//           </div>
//           {savedStatus && (
//             <div className="save-toast">
//               <FaCheckCircle /> Configuration Updated globally
//             </div>
//           )}
//         </header>

//         <div className="settings-layout">
//           {/* Sidebar Navigation */}
//           <aside className="settings-sidebar">
//             <button className={activeSection === 'company' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('company')}>
//               <FaBuilding /> Company Profile
//             </button>
//             <button className={activeSection === 'notifications' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('notifications')}>
//               <FaEnvelope /> Communication
//             </button>
//             <button className={activeSection === 'payments' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('payments')}>
//               <FaCreditCard /> Payment Gateway
//             </button>
//             <button className={activeSection === 'localization' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('localization')}>
//               <FaGlobe /> Region & Data
//             </button>
//             <button className={activeSection === 'branding' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('branding')}>
//               <FaPalette /> Branding & UI
//             </button>
//           </aside>

//           {/* Configuration Forms */}
//           <main className="table-card settings-main">
            
//             {/* 1. Company Information */}
//             {activeSection === 'company' && (
//               <div className="form-section animate-fade">
//                 <div className="section-title">
//                   <h3>Company Information</h3>
//                   <p>Public details used for invoices and reports.</p>
//                 </div>
//                 <div className="form-grid">
//                   <div className="input-group">
//                     <label>Legal Company Name</label>
//                     <input type="text" name="companyName" value={settings.companyName} onChange={handleInputChange} />
//                   </div>
//                   <div className="input-group">
//                     <label>Support Email</label>
//                     <input type="email" name="email" value={settings.email} onChange={handleInputChange} />
//                   </div>
//                   <div className="input-group">
//                     <label>Contact Number</label>
//                     <input type="text" name="phone" value={settings.phone} onChange={handleInputChange} />
//                   </div>
//                   <div className="input-group full-width">
//                     <label>Headquarters Address</label>
//                     <textarea name="address" value={settings.address} onChange={handleInputChange} rows="3"></textarea>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* 2. Notifications Templates */}
//             {activeSection === 'notifications' && (
//               <div className="form-section animate-fade">
//                 <div className="section-title">
//                   <h3>Message Templates</h3>
//                   <p>Customize automated Email and SMS responses.</p>
//                 </div>
//                 <div className="template-list">
//                   <div className="template-item">
//                     <div className="temp-info">
//                       <FaEnvelope className="temp-icon mail" />
//                       <div>
//                         <strong>Welcome Email</strong>
//                         <span>Sent to new users upon registration</span>
//                       </div>
//                     </div>
//                     <button className="btn-secondary" onClick={() => openTemplateEditor('Email')}>Configure</button>
//                   </div>
//                   <div className="template-item">
//                     <div className="temp-info">
//                       <FaMobileAlt className="temp-icon sms" />
//                       <div>
//                         <strong>Payment Receipt (SMS)</strong>
//                         <span>Sent after successful transaction</span>
//                       </div>
//                     </div>
//                     <button className="btn-secondary" onClick={() => openTemplateEditor('SMS')}>Configure</button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* 3. Payment Gateway */}
//             {activeSection === 'payments' && (
//               <div className="form-section animate-fade">
//                 <div className="section-title">
//                   <h3>Payment Gateway</h3>
//                   <p>Configure how you receive payments from clients.</p>
//                 </div>
//                 <div className="input-group">
//                   <label>Primary Merchant</label>
//                   <select name="gateway" value={settings.gateway} onChange={handleInputChange}>
//                     <option value="Bkash">Bkash (Merchant)</option>
//                     <option value="Nogod">Nogod (Personal/Merchant)</option>
//                     <option value="Rocket">Rocket (Dutch Bangla)</option>
//                     <option value="PayPal">PayPal Business</option>
//                   </select>
//                 </div>
//                 <div className="form-grid mt-2">
//                   <div className="input-group">
//                     <label>Merchant ID / API Key</label>
//                     <input type="text" placeholder="Enter ID" defaultValue="TXN_992011" />
//                   </div>
//                   <div className="input-group">
//                     <label>Secret Token</label>
//                     <input type="password" value="********" readOnly />
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* 4. Localization */}
//             {activeSection === 'localization' && (
//               <div className="form-section animate-fade">
//                 <div className="section-title">
//                   <h3>Regional Settings</h3>
//                   <p>Set system date formats and currency symbols.</p>
//                 </div>
//                 <div className="form-grid">
//                   <div className="input-group">
//                     <label><FaClock /> Time Zone</label>
//                     <select name="timezone" value={settings.timezone} onChange={handleInputChange}>
//                       <option>UTC+6 (Dhaka)</option>
//                       <option>UTC+0 (London)</option>
//                       <option>UTC-5 (New York)</option>
//                     </select>
//                   </div>
//                   <div className="input-group">
//                     <label><FaCoins /> Base Currency</label>
//                     <select name="currency" value={settings.currency} onChange={handleInputChange}>
//                       <option value="BDT">BDT (৳)</option>
//                       <option value="USD">USD ($)</option>
//                       <option value="EUR">EUR (€)</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* 5. Branding & Theme */}
//             {activeSection === 'branding' && (
//               <div className="form-section animate-fade">
//                 <div className="section-title">
//                   <h3>Branding & Identity</h3>
//                   <p>Upload your logo and set the system accent color.</p>
//                 </div>
//                 <div className="branding-flex">
//                   <div className="logo-upload-card">
//                     <div className="logo-preview-box">
//                       {settings.logo ? (
//                         <img src={settings.logo} alt="Logo Preview" />
//                       ) : (
//                         <span className="no-logo">No Logo</span>
//                       )}
//                     </div>
//                     <input 
//                       type="file" 
//                       hidden 
//                       ref={fileInputRef} 
//                       onChange={handleLogoUpload}
//                       accept="image/*"
//                     />
//                     <button className="upload-btn-outline" onClick={() => fileInputRef.current.click()}>
//                       <FaUpload /> Replace Logo
//                     </button>
//                   </div>
//                   <div className="theme-card">
//                     <label>Brand Primary Color</label>
//                     <div className="color-control">
//                       <input 
//                         type="color" 
//                         name="primaryColor" 
//                         value={settings.primaryColor} 
//                         onChange={handleInputChange} 
//                       />
//                       <div className="color-details">
//                         <strong>Hex Code</strong>
//                         <code>{settings.primaryColor.toUpperCase()}</code>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="settings-footer">
//               <button className="save-action-btn" onClick={handleSave}>
//                 <FaSave /> Save Global Configuration
//               </button>
//             </div>
//           </main>
//         </div>
//       </div>

//       {/* --- TEMPLATE EDITOR MODAL --- */}
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content large">
//             <div className="modal-header">
//               <h3>Edit {editingTemplate} Template</h3>
//               <button className="close-btn" onClick={() => setIsModalOpen(false)}><FaTimes /></button>
//             </div>
//             <div className="modal-body">
//               <div className="editor-controls">
//                 <span>Available Tags: <code>{"{user_name}"}</code> <code>{"{amount}"}</code> <code>{"{date}"}</code></span>
//               </div>
//               <textarea 
//                 className="template-textarea" 
//                 defaultValue={editingTemplate === 'Email' ? "<h1>Hello {user_name}</h1><p>Welcome to Iconic Green Land.</p>" : "Dear {user_name}, we received your payment of {amount}."}
//               ></textarea>
//             </div>
//             <div className="modal-footer">
//               <button className="btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>
//               <button className="btn-primary" onClick={() => setIsModalOpen(false)}>Update Template</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SystemSettings;


import React, { useState, useRef, useEffect } from 'react';
import { 
  FaBuilding, FaEnvelope, FaCreditCard, FaGlobe, 
  FaPalette, FaSave, FaUpload, FaCheckCircle, 
  FaMobileAlt, FaClock, FaCoins, FaTimes
} from 'react-icons/fa';
 
import './SystemSettings.css';
import { useSettings } from '../../context/SettingsContext';
import { SUPERADMIN_ONLY_LABEL } from '../../constants/roles';
import { isSuperadminUser } from '../../utils/leadershipRoles';
import { superadminErrorMessage, useCurrentUser } from '../../utilities/currentUser';

const SystemSettings = () => {
  
  const { globalSettings, updateSettings } = useSettings();
  const { user } = useCurrentUser();
  // Admin may view the settings; only a Superadmin may change them.
  const canEdit = isSuperadminUser(user);

  const [activeSection, setActiveSection] = useState('company');
  const [savedStatus, setSavedStatus] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const fileInputRef = useRef(null);

  const [settings, setSettings] = useState({
    companyName: '',
    email: '',
    phone: '',
    currency: '',
    timezone: '',
    primaryColor: '#4f46e5',
    secondaryColor: '#64748b',
    gateway: '',
    merchantId: '',
    logo: null,
    address: '',
    defaultBookingFee: 10000,
    defaultDownpayment: 10
  });

  useEffect(() => {
    if (globalSettings) {
      setSettings((prev) => ({ 
        ...prev, 
        ...globalSettings,
        // Fallback default colors if not present in globalSettings
        primaryColor: globalSettings.primaryColor || '#4f46e5',
        secondaryColor: globalSettings.secondaryColor || '#64748b',
        defaultBookingFee: globalSettings.defaultBookingFee || 10000,
        defaultDownpayment: globalSettings.defaultDownpayment || 10
      }));
    }
  }, [globalSettings]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSettings({ ...settings, [name]: value });
    
    // Live Theme Update: Instant feedback for user
    if (name === 'primaryColor') {
      document.documentElement.style.setProperty('--primary', value);
      // Optional: update soft background based on primary
      document.documentElement.style.setProperty('--primary-soft', `${value}1a`);
    }
    if (name === 'secondaryColor') {
      document.documentElement.style.setProperty('--secondary', value);
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSettings({ ...settings, logo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const openTemplateEditor = (type) => {
    setEditingTemplate(type);
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    if (!canEdit) return;
    try {
      await updateSettings(settings);
      setSavedStatus(true);
      setTimeout(() => setSavedStatus(false), 3000);
    } catch (err) {
      alert(superadminErrorMessage(err, "Failed to save settings to server."));
    }
  };

  return (
    <div className="doc-wrapper">
      <div className="doc-container">
        
        <header className="doc-header">
          <div className="header-text">
            <h1>System Configuration</h1>
            <p>Manage global parameters, branding assets, and integration keys.</p>
          </div>
          {savedStatus && (
            <div className="save-toast animate-fade">
              <FaCheckCircle /> Configuration Updated globally
            </div>
          )}
        </header>

        <div className="settings-layout">
          <aside className="settings-sidebar">
            <button className={activeSection === 'company' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('company')}>
              <FaBuilding /> Company Profile
            </button>
            <button className={activeSection === 'notifications' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('notifications')}>
              <FaEnvelope /> Communication
            </button>
            <button className={activeSection === 'payments' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('payments')}>
              <FaCreditCard /> Payment Gateway
            </button>
            <button className={activeSection === 'localization' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('localization')}>
              <FaGlobe /> Region & Data
            </button>
            <button className={activeSection === 'branding' ? 'side-btn active' : 'side-btn'} onClick={() => setActiveSection('branding')}>
              <FaPalette /> Branding & UI
            </button>
          </aside>

          <main className="table-card settings-main">
            {!canEdit && (
              <div className="alert alert-info" role="status">
                {SUPERADMIN_ONLY_LABEL}: you can view these settings, but only a Superadmin can change them.
              </div>
            )}
            <fieldset
              disabled={!canEdit}
              title={canEdit ? undefined : SUPERADMIN_ONLY_LABEL}
              style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}
            >
            
            {activeSection === 'company' && (
              <div className="form-section animate-fade">
                <div className="section-title">
                  <h3>Company Information</h3>
                  <p>Public details used for invoices and reports.</p>
                </div>
                <div className="form-grid">
                  <div className="input-group">
                    <label>Legal Company Name</label>
                    <input type="text" name="companyName" value={settings.companyName} onChange={handleInputChange} />
                  </div>
                  <div className="input-group">
                    <label>Support Email</label>
                    <input type="email" name="email" value={settings.email} onChange={handleInputChange} />
                  </div>
                  <div className="input-group">
                    <label>Contact Number</label>
                    <input type="text" name="phone" value={settings.phone} onChange={handleInputChange} />
                  </div>
                  <div className="input-group full-width">
                    <label>Headquarters Address</label>
                    <textarea name="address" value={settings.address} onChange={handleInputChange} rows="3"></textarea>
                  </div>
                </div>
              </div>
            )}

            {activeSection === 'notifications' && (
              <div className="form-section animate-fade">
                <div className="section-title">
                  <h3>Message Templates</h3>
                  <p>Customize automated Email and SMS responses.</p>
                </div>
                <div className="template-list">
                  <div className="template-item">
                    <div className="temp-info">
                      <FaEnvelope className="temp-icon mail" />
                      <div>
                        <strong>Welcome Email</strong>
                        <span>Sent to new users upon registration</span>
                      </div>
                    </div>
                    <button className="btn-secondary" onClick={() => openTemplateEditor('Email')}>Configure</button>
                  </div>
                  <div className="template-item">
                    <div className="temp-info">
                      <FaMobileAlt className="temp-icon sms" />
                      <div>
                        <strong>Payment Receipt (SMS)</strong>
                        <span>Sent after successful transaction</span>
                      </div>
                    </div>
                    <button className="btn-secondary" onClick={() => openTemplateEditor('SMS')}>Configure</button>
                  </div>
                </div>
              </div>
            )}

            {activeSection === 'payments' && (
              <div className="form-section animate-fade">
                <div className="section-title">
                  <h3>Payment Gateway</h3>
                  <p>Configure how you receive payments from clients.</p>
                </div>
                <div className="input-group">
                  <label>Primary Merchant</label>
                  <select name="gateway" value={settings.gateway} onChange={handleInputChange}>
                    <option value="Bkash">Bkash (Merchant)</option>
                    <option value="Nogod">Nogod (Personal/Merchant)</option>
                    <option value="Rocket">Rocket (Dutch Bangla)</option>
                    <option value="PayPal">PayPal Business</option>
                  </select>
                </div>
                <div className="form-grid mt-2">
                  <div className="input-group">
                    <label>Merchant ID / API Key</label>
                    <input
                      type="text"
                      name="merchantId"
                      placeholder="Enter ID"
                      value={settings.merchantId || ""}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="input-group">
                    <label>Secret Token</label>
                    <input type="password" value="********" readOnly />
                  </div>
                </div>
                
                <div className="section-title mt-4">
                  <h3>Property Booking Defaults</h3>
                  <p>Global default amounts for property listings (can be overridden per property).</p>
                </div>
                <div className="form-grid mt-2">
                  <div className="input-group">
                    <label>Default Booking Fee Amount</label>
                    <input type="number" name="defaultBookingFee" value={settings.defaultBookingFee} onChange={handleInputChange} />
                  </div>
                  <div className="input-group">
                    <label>Default Downpayment Amount</label>
                    <input type="number" name="defaultDownpayment" value={settings.defaultDownpayment} onChange={handleInputChange} />
                  </div>
                </div>
              </div>
            )}

            {activeSection === 'localization' && (
              <div className="form-section animate-fade">
                <div className="section-title">
                  <h3>Regional Settings</h3>
                  <p>Set system date formats and currency symbols.</p>
                </div>
                <div className="form-grid">
                  <div className="input-group">
                    <label><FaClock /> Time Zone</label>
                    <select name="timezone" value={settings.timezone} onChange={handleInputChange}>
                      <option>UTC+6 (Dhaka)</option>
                      <option>UTC+0 (London)</option>
                      <option>UTC-5 (New York)</option>
                    </select>
                  </div>
                  <div className="input-group">
                    <label><FaCoins /> Base Currency</label>
                    <select name="currency" value={settings.currency} onChange={handleInputChange}>
                      <option value="BDT">BDT (৳)</option>
                      <option value="USD">USD ($)</option>
                      <option value="EUR">EUR (€)</option>
                    </select>
                  </div>
                </div>
              </div>
            )}

            {activeSection === 'branding' && (
              <div className="form-section animate-fade">
                <div className="section-title">
                  <h3>Branding & Identity</h3>
                  <p>Upload your logo and set the system theme colors.</p>
                </div>
                <div className="branding-flex">
                  <div className="logo-upload-card">
                    <div className="logo-preview-box">
                      {settings.logo ? (
                        <img src={settings.logo} alt="Logo Preview" />
                      ) : (
                        <span className="no-logo">No Logo</span>
                      )}
                    </div>
                    <input 
                      type="file" 
                      hidden 
                      ref={fileInputRef} 
                      onChange={handleLogoUpload}
                      accept="image/*"
                    />
                    <button className="upload-btn-outline" onClick={() => fileInputRef.current.click()}>
                      <FaUpload /> Replace Logo
                    </button>
                  </div>
                  <div className="theme-card">
                    <div className="color-stack">
                      {/* Primary Color */}
                      <div className="color-item">
                        <label>Primary Brand Color</label>
                        <div className="color-control">
                          <input 
                            type="color" 
                            name="primaryColor" 
                            value={settings.primaryColor} 
                            onChange={handleInputChange} 
                          />
                          <div className="color-details">
                            <strong>Hex Code</strong>
                            <code>{settings.primaryColor.toUpperCase()}</code>
                          </div>
                        </div>
                      </div>
                      
                      {/* Secondary Color */}
                      <div className="color-item mt-3">
                        <label>Secondary Accent Color</label>
                        <div className="color-control">
                          <input 
                            type="color" 
                            name="secondaryColor" 
                            value={settings.secondaryColor} 
                            onChange={handleInputChange} 
                          />
                          <div className="color-details">
                            <strong>Hex Code</strong>
                            <code>{settings.secondaryColor.toUpperCase()}</code>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            </fieldset>

            {canEdit && (
              <div className="settings-footer">
                <button className="save-action-btn" onClick={handleSave}>
                  <FaSave /> Save Global Configuration
                </button>
              </div>
            )}
          </main>
        </div>
      </div>

      {/* --- MODAL REMAINS SAME --- */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content large">
            <div className="modal-header">
              <h3>Edit {editingTemplate} Template</h3>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}><FaTimes /></button>
            </div>
            <div className="modal-body">
              <div className="editor-controls">
                <span>Available Tags: <code>{"{user_name}"}</code> <code>{"{amount}"}</code> <code>{"{date}"}</code></span>
              </div>
              <textarea 
                className="template-textarea" 
                defaultValue={editingTemplate === 'Email' ? "<h1>Hello {user_name}</h1><p>Welcome.</p>" : "Dear {user_name}, payment received."}
              ></textarea>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>
              <button className="btn-primary" onClick={() => setIsModalOpen(false)}>Update Template</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemSettings;